import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ProdConfig } from './core/blocks/config/prod.config';
import { AppMainModule } from './main.module';
import 'ag-grid-enterprise';
import { LicenseManager } from 'ag-grid-enterprise';

LicenseManager.setLicenseKey(
  'Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-063721}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Smarsh,_Inc.}_is_granted_a_{Multiple_Applications}_Developer_License_for_{10}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Charts_and_AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{8}_Production_Environments___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{10_April_2026}____[v3]_[0102]_MTc3NTc3NTYwMDAwMA==148af0f7f8ae16c1c0da97ba4c4b81b5'
);

ProdConfig();

platformBrowserDynamic()
  .bootstrapModule(AppMainModule)
  .then(() => console.log('Application started'))
  .catch((err) => console.error(err));
